export const LifeIcon = (props: any) => (
  <svg
    className={props.className}
    width="24"
    height="34"
    viewBox="0 0 24 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.375 3.25C15.4917 3.25 17.875 5.63333 17.875 8.75C17.875 11.8667 15.4917 14.25 12.375 14.25C9.25833 14.25 6.875 11.8667 6.875 8.75C6.875 5.63333 9.25833 3.25 12.375 3.25ZM12.375 0.5C7.79167 0.5 4.125 4.16667 4.125 8.75C4.125 13.3333 7.79167 17 12.375 17C16.9583 17 20.625 13.3333 20.625 8.75C20.625 4.16667 16.9583 0.5 12.375 0.5Z"
      fill="#34363E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.95833 23.875C4.34227 23.875 2.75 25.4362 2.75 27.8167V33.5H0V27.8167C0 24.3304 2.44106 21.125 5.95833 21.125H18.7917C20.5895 21.125 22.2301 22.1317 23.3313 23.4531L21.2187 25.2136C20.4865 24.335 19.5605 23.875 18.7917 23.875H5.95833Z"
      fill="#34363E"
    />
    <path
      d="M20.8083 25.9834C20.075 25.9834 19.3416 26.3501 18.6083 27.0834C17.875 26.3501 16.9583 25.9834 16.4083 25.9834C14.575 25.9834 13.475 28.1834 15.4916 30.2001L18.6083 33.3167L21.725 30.2001C23.7417 28.3667 22.6417 25.9834 20.8083 25.9834Z"
      fill="#34363E"
    />
  </svg>
);
